import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {
  type RepoPullsDashboardLayoutResponse,
  RepoPullsDashboardLayoutResponseSchema,
} from '@github-ui/dotcom-schema/types/pull_requests/v1/repo_pulls_dashboard'

import {pullRequestsAppBuilder} from '../config/app-builder'
import {
  createRepoPullsProtoPersister,
  type LegacyRepoPullsDashboardLayoutPayload,
  normalizeLegacyRepoPullsLayout,
} from '../helpers/repo-pulls-dashboard-proto'

export function buildRepoPullsDashboardLayoutRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('repoPullsDashboardLayoutRoute', {
    path: '/:owner/:repo',
    queries: [
      mainQuery<RepoPullsDashboardLayoutResponse>({
        schema: RepoPullsDashboardLayoutResponseSchema,
        adapt: legacy => normalizeLegacyRepoPullsLayout(legacy as LegacyRepoPullsDashboardLayoutPayload),
        persister: createRepoPullsProtoPersister(
          RepoPullsDashboardLayoutResponseSchema,
          'repoPullsDashboardLayoutRoute',
        ),
        queryDeps: ({pathname}) => {
          const [, owner, repo] = pathname.split('/')
          return {pathname: `/${owner}/${repo}/pulls/_layout`}
        },
        staleTimeForNavigation: 360000,
      }),
    ],
  })
}

export const repoPullsDashboardLayoutRoute = buildRepoPullsDashboardLayoutRoute(pullRequestsAppBuilder)
